import moment from 'moment';
import localization from 'moment/locale/de';

moment.updateLocale('de', localization);

export const LEO_DATE_FORMAT = 'YYYY-MM-DDTHH:mm:ss';

export function parseDatetimeString(datetimeStr) {
	// our dateformat is like 2018-07-26T00:20:00"
	return moment(datetimeStr, LEO_DATE_FORMAT);
}

export const MONTH_NAMES = {
	0: 'Januar',
	1: 'Februar',
	2: 'März',
	3: 'April',
	4: 'Mai',
	5: 'Juni',
	6: 'Juli',
	7: 'August',
	8: 'September',
	9: 'Oktober',
	10: 'November',
	11: 'Dezember',
};
